import * as React from "react";
import { t } from "i18next";
import { AttrData } from "../AttributeHistrory.types";

export const AttrBoolean: React.FC<AttrData> = ({ value }) => {
  if (value === "true") return t("Yes");
  if (value === "false") return t("No");
  return null;
};
